const API_URL = process.env.REACT_APP_URL_API_MACADAMIA;

export async function apiClient(path: string, options: RequestInit = {}): Promise<Response> {
  const { headers, ...rest } = options;
  return fetch(`${API_URL}${path}`, {
    ...rest,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
  });
}
